import React from 'react';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';
import { useSidebarContext } from '@futrli/shared-services/contexts/sidebar-context/useSidebarContext';

interface CreateDashboardButtonProps {
  variant?: 'primary' | 'secondary';
}

export const CreateDashboardButton = ({ variant = 'primary' }: CreateDashboardButtonProps) => {
  const { dashboard } = useSidebarContext();

  return (
    <Button buttonType={variant} onClick={() => dashboard.open()}>
      <FormattedMessage id="predict.dashboards.create_dashboard" defaultMessage="Create dashboard" />
    </Button>
  );
};
